export default "__VITE_ASSET__BvfDQcCo__"